import Vue from "vue";
import App from "./App.vue";
import router from "./router/";
import VueMask from "v-mask";
import VueI18n from "vue-i18n";
import Vuelidate from "vuelidate";

Vue.use(Vuelidate);
Vue.use(VueI18n);
Vue.use(VueMask);

const i18n = new VueI18n({
  locale: "pt-BR",
  fallbackLocale: "pt-BR",
  messages: {
    en: require("@/i18n/en.json"),
    esp: require("@/i18n/esp.json"),
    de: require("@/i18n/de.json"),
    "pt-BR": require("@/i18n/pt-BR.json"),
  },
});

Vue.config.productionTip = false;

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
